module.exports = __webpack_public_path__ + "static/img/拍照.756f242.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobilPhoneShell3d/imgs/拍照.png
// module id = XhTx
// module chunks = 2